import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import members from "./members";
import { FaLinkedinIn } from "react-icons/fa";

export default function MemberList() {
  const [selectedMemberId, setSelectedMember] = useState(-1);

  const MemberCard = item => {
    return (
      <button
        type="button"
        onClick={() => setSelectedMember(item.id)}
        key={item.id}
        className="relative p-4 rounded-lg hover:shadow-lg block"
      >
        <Image
          layout="responsive"
          width={100}
          height={100}
          alt="Data Mynt team member"
          className="rounded-md"
          src={item.imgSrc}
        />
        <div className="flex flex-col items-center justify-center">
          <span
            className="mt-3"
            style={{
              fontSize: "0.875rem",
              textTransform: "uppercase",
              color: "#1A1A1A",
              fontFamily: "Inter",
              fontWeight: "700"
            }}
          >
            {item.name}
          </span>
          <span
            style={{
              fontSize: "0.875rem",
              textTransform: "uppercase",
              color: "#3D8ECD",
              fontFamily: "Inter",
              fontWeight: "600"
            }}
          >
            {item.position}
          </span>
        </div>
      </button>
    );
  };
  const MemberModal = ({ member }) => (
    <div className="fixed z-10 inset-0 pt-24 bg-black bg-opacity-60 overflow-y-auto flex items-center">
      <div className="flex pt-12 px-4 pb-20 text-center sm:block sm:p-0 w-full justify-center">
        <div
          className="inline-block align-bottom bg-white rounded-lg
                w-full xs:max-w-md sm:max-w-xl md:max-w-2xl lg:max-w-5xl text-left overflow-hidden shadow-xl
                transform transition-all sm:my-8 sm:align-middle"
        >
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 overflow-auto">
            <button
              type="button"
              className="absolute top-2 right-2 text-[#231C5E]"
              onClick={() => setSelectedMember(-1)}
            >
              <Image alt="Close" src="/closeIcon.svg" width={24} height={24} />
            </button>
            <div
              className="flex flex-col sm:flex-row
                        items-center w-full justify-between pt-4"
            >
              <div
                className="bg-primary w-full p-2 rounded-lg bg-gradient-to-b from-primary to-purple-primary
                            mb-6 w-10/12 xs:w-6/12

                            "
              >
                <Image
                  layout="responsive"
                  width="100%"
                  height="100%"
                  src={member.imgSrc}
                />
              </div>
              <div className="w-full p-4">
                <div className="flex flex-row space-x-2">
                  <h5 className="text-base sm:text-2xl">
                    {member.name.toUpperCase()}
                  </h5>
                  <Link href={member.linkedin}>
                    <a
                      className="w-6 h-6 lg:h-8 lg:w-8 flex items-center justify-center text-white bg-primary rounded-full p-2"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaLinkedinIn />
                    </a>
                  </Link>
                </div>
                <h6 className="text-primary text-sm sm:text-xl lg:pt-2">
                  {member.positionFull ? member.positionFull : member.position}
                </h6>
                <p className="mt-2 text-xs md:text-sm lg:text-base lg:pt-4 lg:leading-7">
                  {member.text}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const selectedMember = members.find(m => m.id === selectedMemberId);

  return (
    <div
      className="grid p-4 gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-b border-gray-10"
      style={{ flexWrap: "wrap" }}
    >
      {selectedMember && <MemberModal member={selectedMember} />}
      {members.map(MemberCard)}
    </div>
  );
}
